export default [
  {
    title: 'مدیریت اسلایدشو',
    icon: 'bx bxs-grid',
    children: [
      {
        title: 'اسلایدشو',
        route: { name: 'slideshow' },
        resource: 'SlideshowManager',
        action: 'show',
      },
      {
        title: 'نوع کالاها',
        route: { name: 'division' },
        resource: 'DivisionManager',
        action: 'show',
      },
      {
        title: 'سبک ها',
        route: { name: 'style' },
        resource: 'StyleManager',
        action: 'show',
      },
      {
        title: 'بودجه ها',
        route: { name: 'budget' },
        resource: 'BudgetManager',
        action: 'show',
      },
    ],
  },
]
